<template>
  <div class="feedback-container">
    <el-timeline style="overflow-y: auto;height: calc(100vh - 100px);">
      <el-timeline-item
        icon="el-icon-circle-check"
        type="primary"
        size="large"
        placement="top"
        v-for="(item, index) in listData"
        :key="index"
        :timestamp="item.logTime"
      >
        <span>运单异常由{{ item.createByName }}上报</span>
        <span>情况说明:{{ item.abnormalDesc }}</span>
        <div class="mt-1">
          <swiper class="swiper" ref="swiper" :options="swiperOption">
            <swiper-slide v-for="(image, index) in item.imgs" :key="index">
              <el-image
                class="images"
                v-viewer="{ movable: true }"
                :src="$osscdn(image.imageUrl)"
                @click="imageView"
              />
            </swiper-slide>
          </swiper>
        </div>
      </el-timeline-item>
    </el-timeline>

    <div style="text-align: center" v-if="!listData || !listData.length">
      <img src="/image/static/img/nodata.png" />
      <p class="no-data">暂无数据！</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dispatchOrderCode: String,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      listData: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.dispatchOrderCode) return
      this.$api
        .carrierWaybillSelectAbnormaApi({
          dispatchOrderCode: this.dispatchOrderCode,
        })
        .then((res) => {
          this.listData = res.body.data
        })
    },
    imageView() {
      const viewer = this.$el.querySelector('.images').$viewer
      viewer.show()
    },
  },
}
</script>
